import { render, staticRenderFns } from "./PieCard.vue?vue&type=template&id=c2265988&"
import script from "./PieCard.vue?vue&type=script&lang=js&"
export * from "./PieCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports